import { EarningType, OrderItemStatus, RewardType } from '../enums';

export const LOYALTY_REWARD_TYPE_MAP = {
  [RewardType.DISCOUNT_ENTIRE_SALE]: 'RewardByDiscountEntireSale',
  [RewardType.PRODUCT_DISCOUNT]: 'RewardByDiscountProduct',
  [RewardType.FREE_ITEM]: 'RewardByFreeItem',
};

export const LOYALTY_EARNING_TYPE_MAP = {
  [EarningType.EARN_BY_AMOUNT]: 'EarnByAmount',
  [EarningType.EARN_BY_PURCHASE_ITEM]: 'EarnByPurchaseItem',
};

export const EXCLUDED_ITEM_STATUSES: OrderItemStatus[] = [
  OrderItemStatus.VOID,
  OrderItemStatus.CANCELLED,
];
